import React, { ReactNode } from 'react';
import FAppError from '../FAppError';

type AppError404Props = {
	variant?: 'fullscreen' | 'container';
	content?: string | ReactNode;
};
const AppError404 = (props: AppError404Props) => {
	const { variant, content } = props;

	return <FAppError variant={variant} title="Error 404" content={content} />;
};

AppError404.defaultProps = {
	variant: 'fullscreen',
	content: "Sorry but this page doesn't exist",
};

export default AppError404;
